var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("TopBar", { attrs: { title: "Overview" } }),
      _vm.isLoading
        ? _c("div", { staticClass: "container w-max" }, [_vm._m(0)])
        : _vm._e(),
      _vm.showDateModal
        ? _c("div", { staticClass: "modal overflow-auto" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "flex flex-row space-x-6" }, [
                    _c(
                      "button",
                      {
                        class:
                          _vm.selectedTempDate === _vm.presetDate.today
                            ? "date-selection selected"
                            : "date-selection",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.setDateRange(_vm.presetDate.today)
                          }
                        }
                      },
                      [_vm._v(" Today ")]
                    ),
                    _c(
                      "button",
                      {
                        class:
                          _vm.selectedTempDate === _vm.presetDate.past7Days
                            ? "date-selection selected"
                            : "date-selection",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.setDateRange(_vm.presetDate.past7Days)
                          }
                        }
                      },
                      [_vm._v(" Past 7 days ")]
                    ),
                    _c(
                      "button",
                      {
                        class:
                          _vm.selectedTempDate === _vm.presetDate.past30Days
                            ? "date-selection selected"
                            : "date-selection",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.setDateRange(_vm.presetDate.past30Days)
                          }
                        }
                      },
                      [_vm._v(" Past 30 days ")]
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        _vm.showDateModal = false
                        _vm.tempRange = null
                        _vm.selectedTempDate = null
                      }
                    }
                  },
                  [_c("i", { staticClass: "icn icn-x sm" })]
                )
              ]),
              _c("div", { staticClass: "content pt-6" }, [
                _vm._m(1),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col justify-center items-center h-full mt-4"
                  },
                  [
                    _c("v-date-picker", {
                      ref: "calendar",
                      attrs: {
                        color: "green",
                        columns: 2,
                        "is-range": "",
                        "max-date": _vm.getMaxDate()
                      },
                      on: {
                        dayclick: function($event) {
                          return _vm.selectDateRange()
                        }
                      },
                      model: {
                        value: _vm.tempRange,
                        callback: function($$v) {
                          _vm.tempRange = $$v
                        },
                        expression: "tempRange"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "flex flex-row justify-center items-center mb-6"
                },
                [
                  _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.loadReporting()
                        }
                      }
                    },
                    [_vm._v("Confirm")]
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading && _vm.reporting && _vm.reporting.donations,
              expression: "!isLoading && reporting && reporting.donations"
            }
          ],
          staticClass: "container center"
        },
        [
          _c("div", { staticClass: "flex flex-row justify-between" }, [
            _vm._m(2),
            _c(
              "button",
              {
                staticClass: "dropdown",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.showDateModal = true
                    _vm.tempRange = _vm.range
                    _vm.selectedTempDate = _vm.selectedDate
                  }
                }
              },
              [
                _vm.selectedDate === _vm.presetDate.today
                  ? _c("div", [_vm._v("Today")])
                  : _vm.selectedDate === _vm.presetDate.past7Days
                  ? _c("div", [_vm._v("Past 7 days")])
                  : _vm.selectedDate === _vm.presetDate.past30Days
                  ? _c("div", [_vm._v("Past 30 days")])
                  : _c("div", [_vm._v(_vm._s(_vm.selectedDate))]),
                _c("i", { staticClass: "ml-2 icn icn-chevron-down sm" })
              ]
            )
          ]),
          _vm.reporting && _vm.reporting.donations
            ? _c("div", { staticClass: "flex flex-row space-x-6 mt-6" }, [
                _c("div", { staticClass: "counter-badge" }, [
                  _c("h2", [_vm._v("Total Donations")]),
                  _c("div", { staticClass: "counter" }, [
                    _vm._v(_vm._s(_vm.reporting.donations.totalDonations))
                  ])
                ]),
                _c("div", { staticClass: "counter-badge" }, [
                  _c("h2", [_vm._v("Single Gift")]),
                  _c("div", { staticClass: "counter" }, [
                    _vm._v(
                      _vm._s(
                        _vm.reporting.donations.singleGifts
                          ? _vm.reporting.donations.singleGifts
                          : 0
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "counter-badge" }, [
                  _c("h2", [_vm._v("Regular Gift")]),
                  _c("div", { staticClass: "counter" }, [
                    _vm._v(
                      _vm._s(
                        _vm.reporting.donations.regularGifts
                          ? _vm.reporting.donations.regularGifts
                          : 0
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "counter-badge" }, [
                  _c("h2", [_vm._v("Failed")]),
                  _c("div", { staticClass: "counter" }, [
                    _vm._v(_vm._s(_vm.reporting.donations.failed))
                  ])
                ])
              ])
            : _vm._e(),
          _vm.reporting && _vm.reporting.donations
            ? _c("div", { staticClass: "table mt-6" }, [
                _c("div", { staticClass: "inner" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            on: {
                              click: function($event) {
                                return _vm.sort("transactionDate")
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: [
                                  "s" + _vm.getSortStatus("transactionDate")
                                ]
                              },
                              [_vm._v("Donation Products")]
                            )
                          ]
                        ),
                        _c("th", [_vm._v("Donations")]),
                        _c("th", [_vm._v("Single Gift")]),
                        _c("th", [_vm._v("Regular Gift")])
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.reporting.products, function(product, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _c("div", { staticClass: "text-xl" }, [
                              _vm._v(_vm._s(product.name))
                            ]),
                            _c("div", [
                              _vm._v(_vm._s(_vm._f("titlecase")(product.type)))
                            ])
                          ]),
                          _c("td", { staticClass: "text-xl" }, [
                            _vm._v(_vm._s(product.totalDonations))
                          ]),
                          _c("td", { staticClass: "text-xl" }, [
                            _vm._v(_vm._s(product.singleGifts))
                          ]),
                          _c("td", { staticClass: "text-xl" }, [
                            _vm._v(_vm._s(product.regularGifts))
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chartOptions,
                  expression: "chartOptions"
                }
              ],
              staticClass: "mt-6 bg-white pt-4"
            },
            [_c("div", { attrs: { id: "chart" } })]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Loading")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-row bg-primary-100 items-center rounded" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center mr-2 bg-primary-500 py-2 px-2 rounded-l text-white"
          },
          [_c("i", { staticClass: "icn icn-information-circle" })]
        ),
        _c("div", { staticClass: "py-2 pr-2 text-primary-500" }, [
          _vm._v("Displaying in local timezone")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-row bg-yellow-100 items-center rounded" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center mr-2 bg-yellow-300 py-2 px-2 rounded-l text-white"
          },
          [_c("i", { staticClass: "icn icn-exclamation-circle" })]
        ),
        _c("div", { staticClass: "py-2 pr-2 text-yellow-600" }, [
          _vm._v(
            " This page is in beta testing and is advised not to be used for reporting purposes "
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }